<template>
    <div v-once class="text-muted" :class="`font-${size}`">
        Powered by the Zudello engine
    </div>
</template>

<script>
export default {
    name: 'PoweredByZudello',
    props: {
        size: {
            type: Number,
            default: 14
        }
    }
}
</script>
